// ponytail: single source of truth for API base URL — full URL override takes priority over prefix fallback
export const API_BASE = import.meta.env.VITE_API_BASE_URL
  ?? `https://${import.meta.env.VITE_API_PREFIX ?? "api"}.getlost.cloud`;
